module.exports = __webpack_public_path__ + "7a6ab68e2162f392b65ce158969d7168.webp";